import React, { createContext, useState, useContext, useEffect } from 'react';
import { useWindow } from './WindowContext';
import { useAuth } from './AuthContext';
import { useChatContext } from './AppDataContext';
interface SidebarContextProps {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (value: boolean) => void;
  toggleSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextProps>({
  isSidebarOpen: false,
  setIsSidebarOpen: () => {},
  toggleSidebar: () => {},
});

interface SidebarProviderProps {
  children: React.ReactNode;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const auth = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { windowWidth } = useWindow();
  const { isSpaceChat } = useChatContext();

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
        const newState = !prev;
        localStorage.setItem('isSidebarOpen', JSON.stringify(newState));
        return newState;
      });
  };

 

  useEffect(() => {
    if (isSpaceChat) {
      setIsSidebarOpen(false);
    }
  }, [isSpaceChat]);

  useEffect(() => {
    const savedSidebarState = localStorage.getItem('isSidebarOpen');
    if(auth.user){
        if (savedSidebarState !== null && !isSpaceChat) {
        setIsSidebarOpen(JSON.parse(savedSidebarState));
        }
    }

    if (windowWidth <= 768) {
        setIsSidebarOpen(false);
    }
  }, [windowWidth, auth.user, isSpaceChat]);

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, setIsSidebarOpen, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  return useContext(SidebarContext);
};
